import React from 'react';
import PropTypes from 'prop-types';
import 'react-day-picker/style.css';
import './monthlySubscriptionDayPicker.css';
import { DayPicker } from 'react-day-picker';
import dayjs from 'dayjs';
import {
  MonthlySubscriptionDayPickerContainer,
  WeekHeaderContainer,
  DayLabel,
} from './monthlySubscriptionDayPicker.styles';

const WEEKDAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'];

const MonthlySubscriptionDayPicker = ({ selectedDate, onSelect, fromDate, toDate }) => {
  function getStartOfISOWeek(date) {
    // Get Monday of the week (ISO week starts on Monday)
    const dayOfWeek = dayjs(date).day(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
    const daysFromMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Sunday is 6 days from Monday
    return dayjs(date).subtract(daysFromMonday, 'day').toISOString();
  }

  function getLastDateOfISOWeek(date) {
    // Get Sunday of the week (ISO week ends on Sunday)
    const dayOfWeek = dayjs(date).day(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
    const daysToSunday = dayOfWeek === 0 ? 0 : 7 - dayOfWeek; // Days remaining until Sunday
    return dayjs(date).add(daysToSunday, 'day').toISOString();
  }

  const firstDayOfTheWeek = new Date(getStartOfISOWeek(fromDate));
  const lastDayOfTheWeek = new Date(getLastDateOfISOWeek(toDate));

  const isFirstDateDisabled = date => date.toDateString() === fromDate.toDateString();
  const isOutsideRange = date => date < firstDayOfTheWeek || date > lastDayOfTheWeek;
  const isInSelectedRange = date => selectedDate && date >= fromDate && date <= selectedDate;

  return (
    <MonthlySubscriptionDayPickerContainer id="monthly-subscription-day-picker">
      <WeekHeaderContainer id="week-header" aria-hidden="true">
        {WEEKDAY_LABELS.map(day => (
          <DayLabel key={day}>{day[0]}</DayLabel>
        ))}
      </WeekHeaderContainer>
      <DayPicker
        mode="single"
        timeZone="UTC"
        defaultMonth={fromDate}
        disabled={[fromDate]}
        selected={selectedDate}
        onSelect={onSelect}
        numberOfMonths={fromDate.getDate() === 1 ? 1 : 2}
        components={{
          Nav: () => null,
        }}
        hidden={{ before: fromDate, after: toDate }}
        modifiers={{
          firstDateDisabled: isFirstDateDisabled,
          outsideRange: isOutsideRange,
          selectedRange: isInSelectedRange,
        }}
        classNames={{
          months: 'vertical-months',
          weekday: 'hidden-weekday',
        }}
        modifiersClassNames={{
          firstDateDisabled: 'first-date-disabled',
          outsideRange: 'hidden-day',
          selectedRange: 'highlight-range',
          selected: 'selected-date',
        }}
        weekStartsOn={1}
        labels={{
          labelDayButton: (date, { selected }) => {
            let label = `${date.toDateString()}`;
            if (label === fromDate.toDateString())
              label = `${label} Your current billing date is the ${fromDate.getDate()} of every month`;
            else if (!selected) label = `${label} Unselected. Double tap to select.`;
            else if (selected) label = `${label} Selected. Double tap to unselect.`;
            return label;
          },
        }}
      />
    </MonthlySubscriptionDayPickerContainer>
  );
};

MonthlySubscriptionDayPicker.propTypes = {
  selectedDate: PropTypes.instanceOf(Date),
  onSelect: PropTypes.func.isRequired,
  fromDate: PropTypes.instanceOf(Date).isRequired,
  toDate: PropTypes.instanceOf(Date).isRequired,
};

export default MonthlySubscriptionDayPicker;
